<template>
    <div class="notifications" v-if="user.has_debt || show">
        <div class="notifications__base notifications__warning" v-if="user.has_debt">
            <div class="notifications__container">
                <v-icon class="notifications__icon_debt">report_problem</v-icon>
                <div class="notifications__description">
                    <span class="notifications__title">Importante: </span> {{this.user.has_debt_message}}
                </div>
            </div>
        </div>
        <div class="notifications__base notifications__info" v-if="show" :style="'background-color:' + message.colour">
            <div class="notifications__container notifications__multiple">
                <div class="notifications__multiple__content" v-html="message.description"></div>
                <button class="notifications__view_more"
                    @click="dialog = true"
                    :style="(message.colour.toUpperCase() == '#FFF' || message.colour.toUpperCase() == '#FFFFFF')? 'color: #15C26B; border-color:#15C26B':''"
                    >Ver detalle
                </button>
                <v-icon class="notifications__close"
                    small
                    @click="show = false"
                    :style="(message.colour.toUpperCase() == '#FFF' || message.colour.toUpperCase() == '#FFFFFF')? 'color: #15C26B':'color: #FFF'"
                    >close
                </v-icon>
            </div>
        </div>

        <v-dialog v-model="dialog" content-class="dialog" width="500">
            <v-card>
                <v-card-title>
                    <div class="flex-grow-1"></div>
                    <v-btn icon @click="dialog = false">
                        <v-icon class="iconColor">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-card-text class="notifications_dialog_title">
                    Notificaciones
                </v-card-text>
                <v-card-text class="notifications_dialog_body">
                    <div v-for="(item, index) in testList" :key="index">
                        <div class="notifications_dialog_sub_title">
                            {{ item.title}}
                        </div>
                        <div class="notifications_dialog_detail mb-6 mt-3">
                            <div v-html="item.long_description"></div>
                        </div>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    props: ['user'],
    data() {
        return {
            show: false,
            message: null,
            dialog: false,
            testList: []
        }
    },
    methods: {
        loadNotification(){
          // ORIGINAL
            /* this.notifications.forEach(element => {
                if(element.main){
                    this.show = true;
                    this.message = element
                }
            });  */

            // DEMO

            // this.testList.push(
            //     {
            //         colour:"#15C26B",
            //         title: "Descuentos 2020 [titulo]",
            //         description: `  <i aria-hidden="true" class="v-icon material-icons" style="color:#FF0000">info</i>
            //                         <div class="notifications__description" style="color:#0000FF">
            //                             <span class="notifications__title">¡Aprovecha! </span> los descuentos 2020 que tenemos para ti. <strong>[descripcion]</strong>
            //                         </div>`,
            //         long_description: `Lorem Ipsum is simply dummy text of the printing and typesetting industry. <strong>Lorem Ipsum</strong> has been the industry's standard dummy text ever since the 1500s <strong>[descripcionLarga]</strong>`,
            //         main: true
            //     }
            // )
            // this.testList.push(
            //     {
            //         colour:"#15C26B",
            //         title: "Descuentos 2021 [titulo]",
            //         description: `  <i aria-hidden="true" class="v-icon material-icons" style="color:#FFF">info</i>
            //                         <div class="notifications__description" style="color:#FFF">
            //                             <span class="notifications__title">¡Aprovecha! </span> los descuentos 2020 que tenemos para ti. <strong>[descripcion]</strong>
            //                         </div>`,
            //         long_description: `<strong>Lorem Ipsum</strong> is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s <strong>[descripcionLarga]</strong>`,
            //         main: false
            //     }
            // )
            //
            // this.testList.forEach(element => {
            //     if(element.main){
            //         this.show = true;
            //         this.message = element
            //     }
            // });


        }
    },
    mounted(){
        this.loadNotification();
    },
    computed: {
        ...mapGetters({
            notifications: "notifications"
        })
    }
}
</script>
